export const priceManagerMixin = {
    methods: {
        hasRepeatedTypeGroupsNames(arr) {
            const events = arr.reduce((acc, typeGroup) => {
                if (typeGroup.groupName !== null) {
                    const groupName = typeGroup.groupName.toLowerCase().trim();
                    acc[groupName] = (acc[groupName] || 0) + 1;
                }
                
                return acc;
            }, {});

            return Object.values(events).some(count => count > 1);
        },
        hasEmptyNames(arr) {
            return arr.some(obj => obj.isEmptyName === true);
        },
        isEmptyNameToDelete(arr, obj1) {
            return arr.some(obj => obj.isEmptyName === true && obj1.isEmptyName === obj.isEmptyName);
        },
        noServicesErrorMessage() {
            const waitingTime = 4000;

            this.$toasted.error('You cannot proceed with the action. Please configure a service in the "My Inventory" section before continuing.', 
                { duration: waitingTime }
            );
        }
    },
}



// WEBPACK FOOTER //
// ./src/mixins/priceManager.js